document.addEventListener('DOMContentLoaded', function () {
  // Galerie produit : clic sur une miniature
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var items = gallery.querySelectorAll('.media-item');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var track = gallery.querySelector('[data-track]');
    var dots = gallery.querySelectorAll('[data-dot]');
    var counter = gallery.querySelector('[data-counter]');
    // Téléphone : carrousel au doigt, points et compteur
    if (track && dots.length) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
          if (counter) counter.textContent = (i + 1) + ' / ' + items.length;
          ticking = false;
        });
      }, { passive: true });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          track.scrollTo({ left: track.clientWidth * Number(d.getAttribute('data-dot')), behavior: 'smooth' });
        });
      });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-thumb');
        items.forEach(function (item) {
          item.classList.toggle('is-active', item.getAttribute('data-index') === index);
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
          t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
        });
      });
    });
  });

  // Panier : passer de la carte seule au pack de 2
  // On ajoute d'abord le pack ; on ne retire la carte que si l'ajout a réussi.
  document.querySelectorAll('[data-upsell]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.disabled = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var props = {};
      try {
        var raw = JSON.parse(btn.getAttribute('data-props') || '{}') || {};
        Object.keys(raw).forEach(function (k) {
          if (raw[k] !== null && raw[k] !== '' && k.charAt(0) !== '_') props[k] = String(raw[k]);
        });
      } catch (e) {}
      var fallback = btn.getAttribute('data-fallback');
      var body = new FormData();
      body.append('id', btn.getAttribute('data-variant'));
      body.append('quantity', '1');
      Object.keys(props).forEach(function (k) { body.append('properties[' + k + ']', props[k]); });
      fetch(root + 'cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('add ' + res.status);
          return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: btn.getAttribute('data-key'), quantity: 0 })
          });
        })
        .then(function () { window.location.href = root + 'cart'; })
        .catch(function (err) {
          console.error('[Isula] upsell', err);
          if (fallback) { window.location.href = fallback; } else { btn.disabled = false; }
        });
    });
  });

  // Barre d'achat fixe sur téléphone
  if (document.querySelector('.sticky-buy')) {
    document.body.classList.add('has-sticky-buy');
  }

  // Sélecteur de variante (liste déroulante) : met à jour le prix affiché
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var priceEl = document.querySelector('[data-product-price]');
      if (priceEl && option.getAttribute('data-price')) {
        priceEl.textContent = option.getAttribute('data-price');
      }
      var button = document.querySelector('[data-add-button]');
      if (button) {
        var available = option.getAttribute('data-available') === 'true';
        button.disabled = !available;
        button.textContent = available ? button.getAttribute('data-label') : 'Épuisé';
      }
    });
  });
});
